import { makeStyles } from "@material-ui/core";

export const userRendererStyles = makeStyles((theme) => ({

  iconSection: {
    display: "inline-block",
    backgroundColor: "#aaa",
    borderRadius: "50%",
    width: "60px",
    height: "60px",
    verticalAlign: "top",
    top: "15px",
    position: "relative",
    paddingTop: "12px",
    paddingLeft: "13px"
  },
  detailSection: {
    display: "inline-block",
    left: "20px",
    position: "relative",
    maxWidth: "470px",
  }
  
}));

